import { useEffect, useState, useSyncExternalStore } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const MOBILE_QUERY = '(max-width: 991px)';

const subscribeMobile = (callback) => {
    const mq = window.matchMedia(MOBILE_QUERY);
    mq.addEventListener('change', callback);
    return () => mq.removeEventListener('change', callback);
};

const getMobileSnapshot = () => window.matchMedia(MOBILE_QUERY).matches;

const SideBar = () => {
    const isMobile = useSyncExternalStore(subscribeMobile, getMobileSnapshot, () => true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const { logout } = useAuth();

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_QUERY);
        const onChange = () => {
            if (!mq.matches) setIsMenuOpen(false);
        };
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, []);

    const closeMenu = () => {
        if (isMobile) setIsMenuOpen(false);
    };

    const toggleMenu = () => setIsMenuOpen((prev) => !prev);
    const handleLogout = (e) => {
        e.preventDefault();
        closeMenu();
        logout(navigate);
    };

    return (
        <div className={`side-baar admin-side-baar ${isMenuOpen ? 'menu-open' : ''}`}>
            <div className="mobile-menu-top">
                <div className="logo-dashboard">
                    <Link to="/admin/dashboard">
                        <img src={`${process.env.PUBLIC_URL}/images/logo-dashboard.svg`} alt="LOGO" />
                    </Link>
                </div>
                <button
                    id="admin-mobile-menu-toggle"
                    type="button"
                    className="mobile-menu-toggle-btn"
                    onClick={toggleMenu}
                    aria-expanded={isMenuOpen}
                    aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
                >
                    <span className="mobile-toggle-icon" aria-hidden="true">
                        {isMenuOpen ? '✕' : '☰'}
                    </span>
                </button>
            </div>
            <div className="mobile-menu-panel mobile-drawer">
                    <div className="serch-box">
                        <button>
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </button>
                        <input type="search" placeholder="Search here..." />
                    </div>
                    <div className="menu-list">
                        <span>MAIN MENU</span>
                        <div className="menu-inner">
                            <ul>
                                <li>
                                    <Link
                                        to="/admin/dashboard"
                                        onClick={closeMenu}
                                        className={[
                                            '/admin/dashboard',
                                        ].includes(window.location.pathname) ? 'active' : ''}
                                    >
                                        <i className="bi bi-speedometer2 admin-sidebar-menu-icon" aria-hidden="true" />
                                        Dashboard
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/admin/all-customers"
                                        onClick={closeMenu}
                                        className={[
                                            '/admin/all-customers',
                                        ].includes(window.location.pathname) ? 'active' : ''}
                                    >
                                        <i className="bi bi-people-fill admin-sidebar-menu-icon" aria-hidden="true" />
                                        Customers
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/admin/plans"
                                        onClick={closeMenu}
                                        className={
                                            window.location.pathname === '/admin/plans' ? 'active' : ''
                                        }
                                    >
                                        <i className="bi bi-tags-fill admin-sidebar-menu-icon" aria-hidden="true" />
                                        Plans
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="menu-list">
                        <span>ACCOUNT</span>
                        <div className="menu-inner">
                            <ul>
                                <li>
                                    <Link
                                        to="/admin/my-profile"
                                        onClick={closeMenu}
                                        className={window.location.pathname === '/admin/my-profile' ? 'active' : ''}
                                    >
                                        <img src={`${process.env.PUBLIC_URL}/images/profile-icon-1.png`} alt="my-profile" className='silver-icon' />
                                        My Profile
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/admin/account-setting"
                                        onClick={closeMenu}
                                        className={window.location.pathname === '/admin/account-setting' ? 'active' : ''}
                                    >
                                        <img src={`${process.env.PUBLIC_URL}/images/profile-icon-2.png`} alt="account-setting" className='silver-icon' />
                                        Account Settings
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" onClick={handleLogout}>
                                        <img src={`${process.env.PUBLIC_URL}/images/profile-icon-4.png`} alt="sign-out" className='silver-icon' />
                                        Sign Out
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default SideBar;
